import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from 'environments/environment';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserEmail } from '../models/password-rule';

@Injectable({
    providedIn: 'root'
})
export class ChangePasswordService {

    private API_CHANGE_PASSWORD_URL = environment.ipserver + 'AnA-backend/public/passwordGovernance';

    constructor(private http: HttpClient) { }

    /**
     * Method that change the user password
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-06-08
     * @param app: The application
     * @return Observable with a json that contains a list of applications
     */
    public changePassword(obj: any): Observable<string> {
        const httpHeaders = new HttpHeaders();
        const type = 'text' as 'json';
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.put<string>(`${this.API_CHANGE_PASSWORD_URL}/changePassword`, obj, { headers: httpHeaders, responseType: type });
    }

    /**
     * Method that send the email for change the password
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-06-18
     * @param app: The application
     * @return Observable with a json that contains a list of applications
     */
    public validateEmail(username: string, email: string) {
        const httpHeaders = new HttpHeaders();
        const paramsForReq = new HttpParams()
            .set('userName', `${username}`)
            .set('email', `${email}`);
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.get(`${this.API_CHANGE_PASSWORD_URL}/validateEmail`, { headers: httpHeaders, params: paramsForReq });
    }

     public getUserEmail(username: string) : Observable<UserEmail>{
        const httpHeaders = new HttpHeaders();
        const paramsForReq = new HttpParams()
            .set('userName', `${username}`);
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.get<UserEmail>(`${this.API_CHANGE_PASSWORD_URL}/getUserEmail`, { headers: httpHeaders, params: paramsForReq });
    }

    /**
     * Method that send the email for change the password
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-06-18
     * @param app: The application
     * @return Observable with a json that contains a list of applications
     */
    public sendEmailChangePassword(username: string, email: string): Observable<string> {
        const httpHeaders = new HttpHeaders();
        const paramsForReq = new HttpParams()
            .set('user', `${username}`)
            .set('email', `${email}`);
        httpHeaders.set('Content-Type', 'application/json');
        const type = 'text' as 'json';
        return this.http.get<string>(`${this.API_CHANGE_PASSWORD_URL}/sendEmail`,
            { headers: httpHeaders, params: paramsForReq, responseType: type });
    }

    /**
     * Method that validate if a link for password reset coming from forgot password
     * is still valid. The expiration time is setted in the backend.
     * @author Castor Transformación Digital - Alvaro Felipe Garcia
     * @since 2020-09-17
     */
    public validateLink(usernameCodified: string): Observable<boolean> {
        const body = {
            username: usernameCodified,
            password: ''
        };
        const httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const type = 'text' as 'json';
        return this.http.post<boolean>(`${this.API_CHANGE_PASSWORD_URL}/validateLink`, body, { headers: httpHeaders, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                }))
            ;
    }

    /**
     * Method that register an used link to reset password
     * @author Castor Transformación Digital - Alvaro Felipe Garcia
     * @since 2020-09-24
     */
    public registerUsedLink(usernameCodified: string): Observable<boolean> {
        const body = {
            username: usernameCodified,
            password: ''
        };
        const httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const type = 'text' as 'json';
        return this.http.post<boolean>(
            `${this.API_CHANGE_PASSWORD_URL}/registerUsedLink`,
            body,
            { headers: httpHeaders, responseType: type }
        )
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                }))
            ;
    }
}
